(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/svs-fetch/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/components/core/svs-fetch/assets/javascripts/index.js');


'use strict';

var _svs$core$observabili, _svs$core$config, _svsConfig$ver;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
svs.core.svsFetch = svs.core.svsFetch || {};
const PACKAGE_NAME = 'component:core.svsFetch';
const logger = new svs.core.log.Logger(PACKAGE_NAME);
const _ref = (_svs$core$observabili = svs.core.observability) !== null && _svs$core$observabili !== void 0 ? _svs$core$observabili : {},
  provider = _ref.provider,
  inject = _ref.inject,
  SpanKind = _ref.SpanKind;
const _svs$core$svsFetch$he = svs.core.svsFetch.helpers,
  validateContentType = _svs$core$svsFetch$he.validateContentType,
  validateBaseUrl = _svs$core$svsFetch$he.validateBaseUrl,
  resolveUrl = _svs$core$svsFetch$he.resolveUrl;

const svsConfig = (_svs$core$config = svs.core.config) === null || _svs$core$config === void 0 || (_svs$core$config = _svs$core$config.data) === null || _svs$core$config === void 0 ? void 0 : _svs$core$config.svsconfig;
const localBaseUri = "".concat(window.location.origin, "/api");
const isPreviewEnvironment = svsConfig === null || svsConfig === void 0 || (_svsConfig$ver = svsConfig.ver) === null || _svsConfig$ver === void 0 ? void 0 : _svsConfig$ver.includes('pr');
let svsFetchBaseUri = localBaseUri;
if (isPreviewEnvironment) {
  svsFetchBaseUri = localBaseUri;
} else if (svsConfig !== null && svsConfig !== void 0 && svsConfig.svsFetchBaseUri) {
  svsFetchBaseUri = svsConfig.svsFetchBaseUri;
}

svs.core.svsFetch.create = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const baseUrl = options.baseUrl || '';
  const timeout = options.timeout || 30000;

  validateBaseUrl(baseUrl);

  const tracer = provider === null || provider === void 0 ? void 0 : provider.getTracer(PACKAGE_NAME);

  return async function svsFetch(url) {
    let requestInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let resolvedUrl;
    let parsedUrl;
    const isAbsoluteUrl = url.startsWith('http://') || url.startsWith('https://');
    if (isAbsoluteUrl) {
      resolvedUrl = url;
      parsedUrl = new URL(url);
    } else {
      const base = baseUrl || svsFetchBaseUri;
      if (base) {
        var _resolveUrl = resolveUrl(base, url);
        resolvedUrl = _resolveUrl.resolvedUrl;
        parsedUrl = _resolveUrl.parsedUrl;
      } else {
        resolvedUrl = url;
        parsedUrl = new URL(url, window.location.origin);
      }
    }
    const method = (requestInit.method || 'GET').toUpperCase();

    const headers = new Headers({
      accept: 'application/json'
    });

    if (requestInit.headers) {
      if (requestInit.headers instanceof Headers) {
        requestInit.headers.forEach((value, key) => {
          headers.set(key, value);
        });
      } else {
        Object.entries(requestInit.headers).forEach(_ref2 => {
          let _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];
          headers.set(key, value);
        });
      }
    }

    validateContentType(method, headers);

    const span = tracer === null || tracer === void 0 ? void 0 : tracer.startSpan(PACKAGE_NAME, {
      kind: SpanKind === null || SpanKind === void 0 ? void 0 : SpanKind.CLIENT
    });
    if (span) {
      span.setAttribute('http.request.method', method);
      span.setAttribute('url.full', resolvedUrl);
      span.setAttribute('server.address', parsedUrl ? parsedUrl.hostname : resolvedUrl);
    }

    if (inject && span) {
      const traceHeaders = inject({}, span);
      if (traceHeaders.traceparent) {
        headers.set('traceparent', traceHeaders.traceparent);
      }
    }

    const logUrl = parsedUrl ? "".concat(parsedUrl.origin).concat(parsedUrl.pathname) : resolvedUrl;
    logger.debug("".concat(PACKAGE_NAME, ": ").concat(method, " ").concat(logUrl));

    const abortController = new AbortController();
    const timeoutId = setTimeout(() => abortController.abort(), timeout);

    const onAbort = () => abortController.abort();
    if (requestInit.signal) {
      requestInit.signal.addEventListener('abort', onAbort);
    }

    const fetchOptions = {
      method,
      headers,
      signal: abortController.signal,
      credentials: requestInit.credentials || 'same-origin'
    };

    const optionalProps = ['body', 'mode', 'cache', 'redirect', 'referrer', 'referrerPolicy', 'integrity', 'keepalive'];
    optionalProps.forEach(prop => {
      if (requestInit[prop] !== undefined) {
        fetchOptions[prop] = requestInit[prop];
      }
    });
    let response;
    try {
      response = await fetch(resolvedUrl, fetchOptions);
    } catch (err) {
      if (span) {
        span.recordException(err);
        span.setAttribute('http.response.status_code', 0);
        span.end();
      }

      if (err.name === 'AbortError') {
        const msg = "API request timed out after ".concat(timeout, "ms");
        logger.warn(msg);
        const error = new Error(msg);
        error.name = 'AbortError';
        throw error;
      }
      logger.warn("".concat(PACKAGE_NAME, ": Unable to call API. ").concat(err.toString()));
      throw err;
    } finally {
      clearTimeout(timeoutId);
      if (requestInit.signal) {
        requestInit.signal.removeEventListener('abort', onAbort);
      }
    }

    if (span) {
      span.setAttribute('http.response.status_code', response.status);
      span.end();
    }
    logger.debug("".concat(PACKAGE_NAME, " response: ").concat(response.status, " ").concat(method, " ").concat(logUrl));

    return response;
  };
};

 })(window);